interface CurrentUserRoleFlags {
  isSuperAdminRole?: boolean;
}

/**
 * No.153: only super_admin may edit clinic name / name (kana) — the backend
 * rejects the change with a 422 for any other role (see
 * UpdateClinicRequest::withValidator in sheepmedical-api).
 */
export function canEditClinicName(
  currentUser: CurrentUserRoleFlags | null | undefined,
): boolean {
  return !!currentUser?.isSuperAdminRole;
}

/**
 * No.203: clinic_admin may only edit phone / postal_code / prefecture_id /
 * district / city_id / address / building_name on the clinic edit screen.
 * Every other field (name, name_kana, type, gtm_id, telemedicine_enabled,
 * LP-related settings, etc.) is super_admin-only — the backend rejects any
 * change to these fields from a non-super-admin with a 422 (see
 * UpdateClinicRequest::withValidator in sheepmedical-api).
 */
export function canEditClinicRestrictedField(
  currentUser: CurrentUserRoleFlags | null | undefined,
): boolean {
  return !!currentUser?.isSuperAdminRole;
}
